import { ref, string } from "yup"

export default string()
  .required("Required")
  .min(6, "Must be 6 characters or more")
  .max(20, "Must be 20 characters or less")
  .oneOf([ref("password")], "Passwords must match")
